export interface Token {
  symbol: string;
  name: string;
  decimals: number;
  address: `0x${string}`;
}

interface TokenMap {
  [chain: string]: {
    [symbol: string]: Token;
  };
}

export const TOKENS = {
  BNB: {
    WBNB: {
      symbol: 'WBNB',
      name: 'Wrapped BNB',
      address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      decimals: 18,
    },
    BTCB: {
      symbol: 'BTCB',
      name: 'BTCB Token',
      address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
      decimals: 18,
    },
    USDC: {
      symbol: 'USDC',
      name: 'USDC',
      address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      decimals: 18,
    },
    USDT: {
      symbol: 'USDT',
      name: 'USDT',
      address: '0x55d398326f99059fF775485246999027B3197955',
      decimals: 18,
    },
  },
  BASE_L2: {
    USDC: {
      symbol: 'USDC',
      name: 'USDC',
      address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      decimals: 6,
    },
    USDT: {
      symbol: 'USDT',
      name: 'USDT',
      address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
      decimals: 6,
    },
    WETH: {
      symbol: 'WETH',
      name: 'WETH',
      address: '0x4200000000000000000000000000000000000006',
      decimals: 18,
    },
    cbBTC: {
      symbol: 'cbBTC',
      name: 'cbBTC',
      address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
      decimals: 8,
    },
    EURC: {
      symbol: 'EURC',
      name: 'EURC',
      address: '0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42',
      decimals: 6,
    },
  },
} as const satisfies TokenMap;
